export default __webpack_public_path__ + "static/media/Harpreet kaur.18428a74.webp";